module.exports = __webpack_public_path__ + "img/capa1.ccf54690.webp";